import { Component, HostListener, OnInit } from '@angular/core';
import {PageService} from "../../service/page/page.service";
import {HomeSection} from "../../service/page/page";

@Component({
  selector: 'app-home-section',
  templateUrl: './home-section.component.html',
  styleUrls: ['./home-section.component.scss'],
  providers: [PageService]
})
export class HomeSectionComponent implements OnInit {
  isMobile: boolean = false;
  homeSections: HomeSection.Section[];

  constructor(private pageService: PageService) {
    this.pageService.getHomeSection().subscribe(
      res => {
        this.homeSections = res.sections.filter(({visible}) => visible);
      }
    );
  }


  ngOnInit() {
    this.isMobile = (window.innerWidth < 768);
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home-section/home-section.component.ts